import { render, staticRenderFns } from "./AriPulsePrivacyPage.vue?vue&type=template&id=bc16ec08&scoped=true"
import script from "./AriPulsePrivacyPage.vue?vue&type=script&lang=js"
export * from "./AriPulsePrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./AriPulsePrivacyPage.vue?vue&type=style&index=0&id=bc16ec08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc16ec08",
  null
  
)

export default component.exports